export var BROKER_AGREEMENT_ACCEPTED_KEY = 'newbuilding_broker/agreement_accepted';